<section id="about" >
    <div class="container">
    <header class="section-header">
      <h3 class="section-title">Custom Software Development</h3>
    </header>
    <p class="description">Our Experienced software engineers take charge of converting your business logic into scalable solutions using different technology platforms.
      We offer Custom Software as per they client requirements,
        Based on your requirements we build stand-alone, client-server, web-service driven or data-driven mobile apps. Further, we determine the scope of your mobile development project and outline the solution that best fits your market and business needs
    </p>
    <div class="row row-eq-height justify-content-center">
        <div class="row about-container"> 
            <div class="col-lg-4 background order-lg-2 order-1 wow fadeInUp"> 
              <div class="icon-box wow fadeInUp">
                <div class="icon"><i class="fa fa-windows"></i></div>
                <h4 class="title"><a href="">Windows Application Development </a></h4>
                <p class="description">
    We also provide Windows Application for Bazaar, Crusher's and so on.
                </p>
              </div>
            </div>

            <div class="col-lg-4 background order-lg-2 order-1 wow fadeInUp">
              <div class="icon-box wow fadeInUp">
                  <div class="icon"><i class="fab fa-globe"></i></div>
                  <h4 class="title"><a href="">Web Application Development</a></h4>
                  <p class="description">
                      Our web development team uses modern javascript frameworks like angular & Microsoft tools for backend development.
                  </p>
                </div>      
            </div>
            <div class="col-lg-4 background order-lg-2 order-1 wow fadeInUp">
                <div class="icon-box wow fadeInUp">
                    <div class="icon"><i class="fab fa-mobile"></i></div>
                    <h4 class="title"><a href="">Mobile Application Development</a></h4>
                    <p class="description">
                        We have a high level of expertise on mobile app development skills to build and deploy app's on any mobile platform.
                    </p>
                  </div>      
              </div>
          </div>
      </div>
  </div>
  </section>